import React from 'react';
import { FieldErrors, UseFormReturn } from 'react-hook-form';
import { useUpdateMasterMedicine } from '../../../../apis/master-medicines/hooks/useUpdateMasterMedicine';
import { HealtheraButton } from '../../../../healtheraComponents';
import { MasterMedicine } from '../../../../apis/master-medicines/types';
import { enqueueSnackbar } from 'notistack';

interface Props {
  id: string;
  form: UseFormReturn<MasterMedicine>;
}

const SaveMasterMedicine = ({ id, form }: Props) => {
  const { updateMasterMedicine, isLoading } = useUpdateMasterMedicine();

  const handleSave = async (masterMedicine: MasterMedicine) => {
    await updateMasterMedicine(id, masterMedicine);
    enqueueSnackbar('Master medicine saved', { variant: 'success' });
  };

  const handleInvalidForm = (errors: FieldErrors<MasterMedicine>) => {
    enqueueSnackbar('Please fill in all required fields', { variant: 'error' });
  };

  return (
    <HealtheraButton disabled={isLoading} onClick={form.handleSubmit(handleSave, handleInvalidForm)}>
      Save
    </HealtheraButton>
  );
};

export default SaveMasterMedicine;
